module.exports = __webpack_public_path__ + "static/media/ios-star-half.6110aa78.svg";